"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Vector = _interopRequireDefault(require("ol/layer/Vector"));
var _Vector2 = _interopRequireDefault(require("ol/source/Vector"));
var _antd = require("antd");
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
require("./SearchResultsPanel.less");
var _useMap = _interopRequireDefault(require("../../Hook/useMap"));
var _excluded = ["searchResults", "numTotal", "searchTerms", "actionsCreator", "listPrefixRenderer", "layerStyle"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Panel = _antd.Collapse.Panel;
var ListItem = _antd.List.Item;
var SearchResultsPanel = function SearchResultsPanel(props) {
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    highlightLayer = _useState2[0],
    setHighlightLayer = _useState2[1];
  var map = (0, _useMap["default"])();
  var searchResults = props.searchResults,
    numTotal = props.numTotal,
    searchTerms = props.searchTerms,
    _props$actionsCreator = props.actionsCreator,
    actionsCreator = _props$actionsCreator === void 0 ? function () {
      return undefined;
    } : _props$actionsCreator,
    _props$listPrefixRend = props.listPrefixRenderer,
    listPrefixRenderer = _props$listPrefixRend === void 0 ? function () {
      return undefined;
    } : _props$listPrefixRend,
    layerStyle = props.layerStyle,
    passThroughProps = _objectWithoutProperties(props, _excluded);
  (0, _react.useEffect)(function () {
    var layer = new _Vector["default"]({
      source: new _Vector2["default"]()
    });
    if (layerStyle) {
      layer.setStyle(layerStyle);
    }
    setHighlightLayer(layer);
    map.addLayer(layer);
  }, []);
  (0, _react.useEffect)(function () {
    return function () {
      map.removeLayer(highlightLayer);
    };
  }, [highlightLayer]);
  var highlightSearchTerms = function highlightSearchTerms(text) {
    searchTerms.forEach(function (searchTerm) {
      var term = searchTerm.toLowerCase();
      if (term === '') {
        return;
      }
      var start = text.toLowerCase().indexOf(term);
      while (start >= 0) {
        var startPart = text.substring(0, start);
        var matchedPart = text.substring(start, start + term.length);
        var endPart = text.substring(start + term.length, text.length);
        text = "".concat(startPart, "<b>").concat(matchedPart, "</b>").concat(endPart);
        start = text.toLowerCase().indexOf(term, start + 8);
      }
    });
    return text;
  };
  var onMouseOver = function onMouseOver(feature) {
    return function () {
      var _highlightLayer$getSo, _highlightLayer$getSo2;
      highlightLayer === null || highlightLayer === void 0 ? void 0 : (_highlightLayer$getSo = highlightLayer.getSource()) === null || _highlightLayer$getSo === void 0 ? void 0 : _highlightLayer$getSo.clear();
      highlightLayer === null || highlightLayer === void 0 ? void 0 : (_highlightLayer$getSo2 = highlightLayer.getSource()) === null || _highlightLayer$getSo2 === void 0 ? void 0 : _highlightLayer$getSo2.addFeature(feature);
    };
  };

  /**
   * Renders content panel of related collapse element for each category and
   * its features.
   *
   * @param category The category to render
   * @param categoryIdx The idx of the category in the searchResults list.
   */
  var renderPanelForCategory = function renderPanelForCategory(category, categoryIdx) {
    var features = category.features,
      title = category.title,
      icon = category.icon;
    if (!features || (0, _isEmpty2["default"])(features)) {
      return;
    }
    var header = /*#__PURE__*/_react["default"].createElement("div", {
      className: "search-result-panel-header"
    }, /*#__PURE__*/_react["default"].createElement("span", null, "".concat(title, " (").concat(features.length, ")")), icon && /*#__PURE__*/_react["default"].createElement(_antd.Avatar, {
      className: "search-option-avatar",
      src: icon
    }));
    var categoryKey = getCategoryKey(category, categoryIdx);
    return /*#__PURE__*/_react["default"].createElement(Panel, {
      header: header,
      key: categoryKey
    }, /*#__PURE__*/_react["default"].createElement(_antd.List, {
      size: "small",
      dataSource: features.map(function (feat, idx) {
        var text = highlightSearchTerms(feat.get('title'));
        return {
          text: text,
          idx: idx,
          feature: feat
        };
      }),
      renderItem: function renderItem(item) {
        return /*#__PURE__*/_react["default"].createElement(ListItem, {
          className: "result-list-item",
          key: item.idx,
          onMouseOver: onMouseOver(item.feature),
          onMouseOut: function onMouseOut() {
            var _highlightLayer$getSo3;
            return highlightLayer === null || highlightLayer === void 0 ? void 0 : (_highlightLayer$getSo3 = highlightLayer.getSource()) === null || _highlightLayer$getSo3 === void 0 ? void 0 : _highlightLayer$getSo3.clear();
          },
          onClick: function onClick() {
            return map.getView().fit(item.feature.getGeometry(), {
              size: map.getSize()
            });
          },
          actions: actionsCreator(item)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "result-prefix"
        }, listPrefixRenderer(item)), /*#__PURE__*/_react["default"].createElement("div", {
          className: "result-text",
          dangerouslySetInnerHTML: {
            __html: item.text
          }
        }));
      }
    }));
  };

  /**
   * Create a category key that is based on the category title and its position in searchResults.
   *
   * @param category The category to create the key for.
   * @param idx The position of the category in searchResults.
   * @returns The created key for the category.
   */
  var getCategoryKey = function getCategoryKey(category, idx) {
    return "".concat(category.title, "-").concat(idx);
  };
  if (numTotal === 0) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "search-result-div"
  }, /*#__PURE__*/_react["default"].createElement(_antd.Collapse, _extends({
    defaultActiveKey: searchResults[0] ? getCategoryKey(searchResults[0], 0) : undefined
  }, passThroughProps), searchResults.map(renderPanelForCategory)));
};
var _default = SearchResultsPanel;
exports["default"] = _default;